import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import "./SingleArtist.css";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Product from "../Product/Product";
import axios from "axios";
import { useParams } from "react-router-dom";
import SingleArtistProduct from "./SingleArtistProduct";

const SIngleArtist = (props) => {
  const [artist, setArtist] = useState("");
  const { artistId } = useParams();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios.get(`https://skabelse.herokuapp.com/artist/${artistId}`).then((res) => {
      setArtist(res.data);
    });
  }, []);

  useEffect(() => {
    axios.get("https://skabelse.herokuapp.com/painting/").then((res) => {
      setProducts(res.data);
    });
  }, []);

  return (
    <div className="singleArtist">
      <Header />
      <SubHeader
        title="Artist Profile"
        text="Artist Profile"
        width="container"
      />
      <div className="single_artist_profile">
        {/* single_artist_profile_top */}
        <div className="container">
          {/* single_artist_profile_top */}
          <div className="single_artist_profile_top mb-5">
            <div className="row">
              {/* leftbar */}
              <div className="col-xl-3">
                <div className="single_artist_profile_image mb-4">
                  <img src={artist?.artist_image} alt="" />
                </div>
                <div className="single_artist_profile_content text-white">
                  <h4 className="semibold">{artist.artist_name}</h4>
                  <p>{artist.artist_country}</p>
                  <div className="d-flex flex-wrap justify-content-between button_group mb-4">
                    <button
                      type="button"
                      className="allbutton cl_b px4_5 py-2 mb-3"
                      onclick="location.href='/'"
                    >
                      Contact
                    </button>
                    <button
                      type="button"
                      className="allbutton cl_y px4_5 py-2 mb-3"
                      onclick="location.href='/'"
                    >
                      Follow
                    </button>
                  </div>
                  <div className="single_artist_profile_table ">
                    <table class="table table-borderless text-white">
                      <tbody>
                        <tr>
                          <td className="py-0">Artworks</td>
                          <td className="py-0">Followers</td>
                          <td className="py-0">
                            Reviews
                            <span className="ms-2 cl-pm">(4,256)</span>
                          </td>
                        </tr>
                        <tr className="text-center">
                          <td className="py-0">
                            <h2 className="bold m-0">486</h2>
                          </td>
                          <td className="py-0">
                            <h2 className="bold m-0">1,946</h2>
                          </td>
                          <td className="py-0">
                            <h2 className="bold m-0">4.94</h2>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* rightbar */}
              <div className="col-xl-9">
                {/* artist */}
                <div className="text-white mb-5">
                  <h5 className="semibold mb-4">Artist</h5>
                  <p>{artist.artistry}</p>
                </div>
                {/* Education */}
                <div className="text-white mb-5">
                  <h5 className="semibold mb-4">Education</h5>
                  <p>{artist.education}</p>
                </div>
                {/* Events */}
                <div className="text-white mb-5">
                  <h5 className="semibold mb-4">Events</h5>
                  <p className="my-1">About my work :</p>
                  {/* link tag */}
                  <div className="artist_aboutWork_link">
                    <a href="http://levenshorizonten.com">
                      <p className="m-0">http://levenshorizonten.com</p>
                    </a>
                    <a href="www.behance.net/jeanhacquin">
                      <p className="m-0">www.behance.net/jeanhacquin</p>
                    </a>
                    <a href="http://vimeo.com/jeanhacquin">
                      <p className="m-0">http://vimeo.com/jeanhacquin</p>
                    </a>
                  </div>
                </div>
                {/* Exhibition */}
                <div className="text-white mb-5">
                  <h5 className="semibold mb-4">Exhibitions</h5>
                  <div className="">
                    <Timeline>
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                          <h5 className="semibold cl-pm">2020</h5>
                          <p>
                            until now: Homage to Joseph Beuys - pigments-collage
                            - wooden boxes- Nijmegen Radboud University
                          </p>
                        </TimelineContent>
                      </TimelineItem>

                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot />
                          {/* <TimelineConnector /> */}
                        </TimelineSeparator>
                        <TimelineContent>
                          <h5 className="semibold cl-pm">2019</h5>
                          <p>
                            Life of Mary 17 paintings* 2017: 9 Faces of Christ
                            before and during his Passion - Chaplaincy Radboud
                            University Nijmegen
                          </p>
                        </TimelineContent>
                      </TimelineItem>
                    </Timeline>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* single_artist_profile_bottom */}
          <div className="single_artist_profile_bottom mb-5">
            <div className="button_list">
              <div className="d-flex">
                <button
                  type="button"
                  className="all_fixed_button button_active   px4_5 py-2 my-3 me-3"
                >
                  Artworks <span>(823)</span>
                </button>
                <button
                  type="button"
                  className="all_fixed_button   px4_5 py-2 my-3 me-3"
                >
                  Collections <span>(723)</span>
                </button>
                <button
                  type="button"
                  className="all_fixed_button   px4_5 py-2 my-3 me-3"
                >
                  Favourites <span>(923)</span>{" "}
                </button>
              </div>
            </div>
            <div className={`productCategory d-flex ${props.background}`}>
              <div className="productCard">
                {products.map((product) => (
                  <SingleArtistProduct
                    key={product.id}
                    product={product}
                    artist={artist}
                  ></SingleArtistProduct>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer displayNone="d-none" />
    </div>
  );
};

export default SIngleArtist;
